import Controller from "./holiday.controller";
import template from "./holiday.html";

const holiday = {
  template,
  controller: Controller,
};

export default holiday;



// WEBPACK FOOTER //
// ./src/pages/holiday/holiday.component.js